<template>
<div class="zt-box">
  <van-nav-bar placeholder title="待支付" left-text="" left-arrow @click-left="onClickLeft()">
    <template #right>
    </template>
  </van-nav-bar>
  <div class="zt-info">
    <h1>{{ data.curriculumName }}</h1>
    <span><em>机构名称：</em><b>{{ data.institutionName }}</b></span>
    <span><em>上课时间：</em><b>{{ data.classTime }}</b></span>
    <span><em>总课时：</em><b>{{ data.classHour }}</b></span>
    <span class="bmpre"><em>报名价格：</em><b class="pre">￥{{ data.price }}</b></span>
  </div>
  <div class="techer">
    <b>任课老师</b>
    <span>
        <em>{{ data.teacherName }}</em>
      </span>
  </div>

  <div class="kc-detial">
    <b>课程详情</b>
    <dl>
      <dt>上课地点：</dt>
      <dd>{{ data.address }}</dd>
    </dl>
    <dl>
      <dt>开班日期：</dt>
      <dd>{{ data.startDate }}</dd>
    </dl>
    <dl>
      <dt>课程简介：</dt>
      <dd>{{ data.introduction }}</dd>
    </dl>
    <div  v-if="data.pic" class="d-img">
      <img v-for="(e,i) in data.pic.split(',')" :key="i" :src="fileDisplayPrefix +  e" />
    </div>
  </div>
  <div class="techer">
    <b>学员姓名</b>
    <span>
        <em>{{ data.studentName }}</em>
      </span>
  </div>

  <div style="height:65px"></div>
  <div class="bm-but-box" v-if="data.status === '0'">
      <span>
        <p>名额：<b>{{ data.planCount }}</b></p>
        <p>报名人数：<b>{{ data.realCount }}</b></p>
      </span>
      <van-button  round block type="info"  @click="pay()" class="tj-but" native-type="submit" id="timess" ></van-button>
  </div>
</div>

</template>

<script>
import {getUnpaidDetailById, pay} from "../../api/course/course";
import {FILE_DISPLAY_PREFIX} from "../../api/upload";
import { JSBridgeExec } from '@/utils/alipayJSBridge'

export default {
name: "unpaid",
  data(){
   return{

     countDown : '',
     data:{},
     timer:'',
     time:{  seconds:'',minutes:''},
     fileDisplayPrefix:FILE_DISPLAY_PREFIX

   }
  },
  created() {
    this.data.id = this.$route.query.id
    getUnpaidDetailById(this.$route.query.id).then(res =>{
      if (res.code === 10000){
        this.data = res.result
       this.countDown = res.result.countDown
      }
    })

  },
  mounted() {
    this.timer = setInterval(() =>{
      this.countTimer()
    }, 1000);
  },
  beforeDestroy(){  //销毁前
    clearInterval(this.timer);
  },
  methods:{


    countTimer(){
      if (this.countDown >= 0) {
        const  minutes = Math.floor(this.countDown / 60);
        const seconds = Math.floor(this.countDown % 60);
        const msg ="立即支付"+ minutes + "分" + seconds + "秒";
        document.getElementById("timess").innerHTML = msg;
        --this.countDown;
      }else {
        const msg ="已过期";
        document.getElementById("timess").innerHTML = msg;
        document.getElementById("timess").setAttribute("disabled", "true");
        clearInterval(this.timer);
      }
    },


    onClickLeft(){
      this.$router.push({path: `/course`})
    },

    pay(){
      pay({ id: this.data.id, redirectUrl: document.location.href }).then(res => {
        if (res.code === 10000) {
          JSBridgeExec(res.result)
        }
      })

    }

  }
}
</script>

<style scoped>
.bm-but-box{
  display: flex;
  padding: 0 14px;
  align-items: center;
  justify-content: space-between;
  height:66px;
  border-top: 1px solid #dedede;
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  background: #ffffff;
  z-index: 999999;
}
.bm-but-box span{
  display: flex;
  align-items: center;
}
.bm-but-box span p{
  font-size:14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-right: 10px;
}
/deep/.tj-but {
  display: flex;
  padding:0 3px;
  background: url("~@/assets/button-style.png") 3px 3px no-repeat #FF9900;
  background-size: 11px 15px;
  border-radius: 25px;
  width:130px;
  height:44px;
  align-items: center;
  justify-content: center;
  border: none;
  font-size:14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FFFFFF;
}
.zt-box{
  padding:0;
}
.zt-info{
  display: flex;
  flex-direction: column;
  background: #F4F5F7;
  border-radius:12px;
  padding: 24px;
  margin: 0 10px;
  margin-top: 10px;
}
.zt-info span em{
  display: flex;
  width: 70px;
}
.zt-info h1{
  display: flex;
  font-size:19px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  margin-bottom:14px;
  line-height: 1.2;
}
.zt-info span{
  display: flex;
  /*height:14px;*/
  font-size:14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #777777;
  align-items: flex-start;
  margin-bottom:13px;
}
.zt-info span.bmpre{
  align-items: center;
}
.zt-info span b{
  color: #333333;
  font-weight: normal;
  display: flex;
  flex: 1;
}
.zt-info span b.pre{
  font-size:18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FF9900;
}
.zt-info span:last-child{
  margin-bottom: 0;
}
.techer{
  display: flex;
  flex-direction: column;
  padding:20px 14px;
  border-bottom: 5px solid #f8f8f8;
}
.techer b{
  display: flex;
  height:15px;
  font-size:16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  margin-bottom: 15px;
}
.techer span{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.techer span em{
  display: flex;
  height:28px;
  background: #F4F5F7;
  border-radius:100px;
  padding: 0 11px;
  font-size:12px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  align-items: center;
  margin-right: 9px;
}
.kc-detial{
  padding:20px 14px;
  border-bottom: 5px solid #f8f8f8;
}
.kc-detial b{
  display: flex;
  height:15px;
  font-size:16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  margin-bottom: 15px;
}
.kc-detial dl{
  display: flex;
  margin-bottom:10px;
}
.kc-detial dl dt{
  display: flex;
  font-size:14px;
  color: #777777;
  width:70px;
  padding-top:3px;
}
.kc-detial dl dd{
  display: flex;
  flex: 1;
  font-size:14px;
  color: #333333;
  line-height: 20px;
}
.d-img img{
  width: 100%;
  margin-bottom: 5px;
}
</style>
